import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const Loader = ({ style }) => {
  return (
    <Wrapper style={style}>
      <Spin indicator={<LoadingOutlined spin />} size="large"/>
    </Wrapper>
  );
};

export default Loader;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 800;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, .3);
`;
